

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService, Core2Config, ApiVisa, ApiResponseModel } from '../../shared';

// /core2/platform/dm/sysadmin/switch-users

@Injectable({
  providedIn: 'root'
})
export class SwitchUserService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'sysadmin/switch-users';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'sysadmin/switch-users';
    this.httpClient = http;
  }
  

  // /core2/platform/dm/sysadmin/switch-users/get-switch-user-authorization-token/sysadmin-ep
  replicateDataToTenantSysadminEP(dtoObject: any, apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (apiVisa && apiVisa.api_domain_url != null) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path
    }
    const url = this.apiUrl + '/get-switch-user-authorization-token/sysadmin-ep';
    return this.httpClient.post<ApiResponseModel<AnalyserOptions>>(
      url,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }
}

